import React, { useState, useRef, useEffect } from 'react';

import {
  Bold,
  Button,
  CardText,
  ButtonLink,
  TextInputFull,
  FlexContainer
} from './Styled';
import LoadingSpinner from 'components/LoadingSpinner';

export const FileNumber = (props) => {
  const [editing, setEditing] = useState(false);
  const lastUpdatedRef = useRef(props.orderUpdated);
  const [fileNumber, setFileNumber] = useState(props.fileNumber);

  useEffect(
    function resetOnUpdate() {
      if (lastUpdatedRef.current !== props.orderUpdated) {
        lastUpdatedRef.current = props.orderUpdated;
        setEditing(false);
      }
    },
    [props.orderUpdated]
  );

  const toggleEditing = () => {
    setEditing((s) => !s);
    setFileNumber(props.fileNumber);
  };

  const handleFileChange = (name, value) => {
    setFileNumber(value);
  };

  const handleSubmit = () => {
    props.updateOrder({ file_number: fileNumber });
  };

  const renderEdit = () => {
    return (
      <div>
        <CardText>
          <Bold>File Reference</Bold>
        </CardText>

        {props.loading && <LoadingSpinner />}

        {!props.loading && (
          <FlexContainer style={{ height: 40 }}>
            <TextInputFull
              bold
              name="file_number"
              value={fileNumber}
              onChange={handleFileChange}
              placeholder="Enter the file reference"
              errorText={props.inputErrors.file_number}
            />

            <div style={{ display: 'flex', marginLeft: 8 }}>
              <Button secondary onClick={toggleEditing} style={{ marginRight: 4 }}>
                Cancel
              </Button>
              <Button onClick={handleSubmit}>Save</Button>
            </div>
          </FlexContainer>
        )}
      </div>
    );
  };

  const renderDisplay = () => {
    return (
      <CardText>
        <Bold>File Reference</Bold>
        {fileNumber || 'None Provided'}

        <ButtonLink onClick={toggleEditing}>Edit</ButtonLink>
      </CardText>
    );
  };

  return <div>{editing ? renderEdit() : renderDisplay()}</div>;
};

export default FileNumber;
